/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedTradePointsEarnedMessage_item = {
    readonly " $fragmentRefs": FragmentRefs<"PointsEarnedMessage_item">;
    readonly " $refType": "PdpSharedTradePointsEarnedMessage_item";
};
export type PdpSharedTradePointsEarnedMessage_item$data = PdpSharedTradePointsEarnedMessage_item;
export type PdpSharedTradePointsEarnedMessage_item$key = {
    readonly " $data"?: PdpSharedTradePointsEarnedMessage_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradePointsEarnedMessage_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedTradePointsEarnedMessage_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PointsEarnedMessage_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'b4564013a742508ef0b0abcce0455daf';
export default node;
